import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {RGBFormatFromDecimal, decimaltoHex} from '../../../../utilities/common';
import {isEmpty} from '../../../../utilities/validation';
import {parseStudentAnswer} from '../../../../utilities/xml';
import {disableOverlayMask} from '../../../../events/event-handler';


const getDataFromNode = function(node) {
    const nodeDict = ['id', 'x', 'y', 'height', 'width', 'text_align', 'border_style',
        'bgcolor', 'visible', 'bgalpha', 'variable', 'line_height', 'fontcolor', 'value'].reduce((data, key) => {
        return { ...data, [key]: node.attr[key] };}, { val: node.val });
    return nodeDict;
};

class TextArea extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node)
        };

        this.enableTA = this.enableTA.bind(this);
        this.showTA = this.showTA.bind(this);
        this.hideTA = this.hideTA.bind(this);
    }

    componentDidMount() {
        document.addEventListener('jre-te-enabled', this.enableTA);
        document.addEventListener('jre-text-show', this.showTA);
        document.addEventListener('jre-text-hide', this.hideTA);
    }

    componentWillUnmount() {
        document.removeEventListener('jre-te-enabled', this.enableTA);
        document.removeEventListener('jre-text-show', this.showTA);
        document.removeEventListener('jre-text-hide', this.hideTA);
    }

    enableTA(e) {
        if (this.state.id === e.detail.target) {
            this.setState({overlayMask: false, enabled: true});
            disableOverlayMask();
        }
    }

    showTA(e) {
        if (this.state.id === e.detail.target) {
            this.setState({overlayMask: false, visible: '1'});
        }
    }
    hideTA(e) {
        if (this.state.id === e.detail.target) {
            this.setState({visible: false});
        }
    }

    render() {
        let {x = 0, y = 0, height = 0, width = 0, text_align = 'left', border_style = 'none', bgcolor, bgalpha = '',
            visible = '1', id, line_height = '', fontcolor, value = '', variable = ''
        } = this.state;
        const {fontsize = '', answer = '', studentAnswers = {}} = this.props;

        if(!isEmpty(studentAnswers) && !isEmpty(variable)) {
            value = parseStudentAnswer(studentAnswers, variable);
        }

        if(border_style === 'solid') {
            x = x - 2;
            y = y - 2;
            height = parseInt(height) + 4;
            width = parseInt(width) + 4;
        }
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            display: visible === '1' ? 'block' : 'none'
        };
        const textAreaStyle = {
            textAlign: text_align,
            border: border_style,
            height: `${height}px`,
            width: `${width}px`,
            backgroundColor: !isEmpty(bgcolor) ? RGBFormatFromDecimal(bgcolor, bgalpha) : 'transparent',
            color: fontcolor ? `#${decimaltoHex(fontcolor)}` : 'inherit',
        };
        if (fontsize) {
            textAreaStyle.fontSize = `${fontsize}px`;
        }
        if(line_height) {
            textAreaStyle.lineHeight= `${line_height}px`;
        }
        if (!isEmpty(this.props.fontcolor)){
            // sometimes color is defined in parent node of XML, ex in te-node Immunology 3.0.2 pg 511 (MOD-1042)
            // when the above condition is met we pass fontcolor as props from parent and use it to define color
            // attribute of this element
            textAreaStyle.color = `#${decimaltoHex(this.props.fontcolor)}`;
        }
        if(!isEmpty(answer)){
            value = answer;
        }
        return (
            <div className="node textarea-node" style={divStyle}>
                <textarea className="jre-textarea" style={textAreaStyle} value={value} name={id}
                          onChange={this.props.onChange}>
                </textarea>
            </div>
        );
    }
}

TextArea.propTypes = {
    node: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return {
        studentAnswers: state.answers.list
    };
};

const TextAreaNode = connect(
    mapStateToProps,
    null
)(TextArea);

export default TextAreaNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/textarea-node.js